import Vue from 'vue'
import { formatRG } from '../plugins/formatters'

Vue.directive('validate-rg', {
  bind (el, binding, vnode) {
    Vue.nextTick(() => {
      const input = el.querySelector('input')
      if (!input) return
      input.addEventListener('beforeinput', handleBeforeInput)
      input.addEventListener('input', () => formatAndUpdate(input, vnode))
      formatAndUpdate(input, vnode)
    })
  },

  update (el, binding, vnode) {
    Vue.nextTick(() => {
      const input = el.querySelector('input')
      if (input) {
        formatAndUpdate(input, vnode)
      }
    })
  }
})

function handleBeforeInput (event) {
  const allowedPattern = /^[0-9a-zA-Z]+$/
  if (event.data && !allowedPattern.test(event.data)) {
    event.preventDefault()
  }
}

function formatAndUpdate (input, vnode) {
  const formatted = formatRG(input.value)
  if (input.value !== formatted) {
    input.value = formatted
    Vue.nextTick(() => {
      if (vnode && vnode.componentInstance && typeof vnode.componentInstance.$emit === 'function') {
        vnode.componentInstance.$emit('input', formatted)
      } else {
        input.dispatchEvent(new Event('input', { bubbles: true }))
      }
    })
  }
}
